import { BaseEntity } from "./BaseEntity";
import { SkillCriteria } from "./SkillCriteria";
import { Training } from "./Training";

export class Skill extends BaseEntity {
    public name: string = "";
    public skillCriterias?: string[] | SkillCriteria[] = [];
    public training?: string | Training = "";

    constructor(model: Partial<Skill> = {}) {
        super(model?.id);
        Object.assign(this, model);
    }
}

export type PSkill = Partial<Skill>;
